//音频下载域名文件

if(/dev-m/.test(window.location.href)){
	var domainDownload="http://devadmin.docbook.com.cn";
}else if(/test-m/.test(window.location.href)){
	var domainDownload="http://testadmin.docbook.com.cn";
}else if(/release-m/.test(window.location.href)){
	var domainDownload="http://releaseadmin.docbook.com.cn";
}else if(/localhost/.test(window.location.href)){
	var domainDownload="http://testadmin.docbook.com.cn";
}else if(/192.168/.test(window.location.href)){
	var domainDownload="http://releaseadmin.docbook.com.cn";
}else if(/test-heartm.docbook.com.cn/.test(window.location.href)){
	var domainDownload="http://testadmin.docbook.com.cn";
}else if(/release-heartm.docbook.com.cn/.test(window.location.href)){
	var domainDownload="http://releaseadmin.docbook.com.cn";
}else if(/heartm.docbook.com.cn/.test(window.location.href)){
	var domainDownload="http://admincenter.docbook.com.cn";
}else{
	var domainDownload="http://admincenter.docbook.com.cn";
}

export default {
    testUrl: domainDownload
}